import { z } from 'zod';

import zodLocales from 'common/zod/locales';

export const markAsPaidModalSchema = z.object({
  amountPaid: z
    .number({
      invalid_type_error: zodLocales.errors.amount,
    })
    .nonnegative(zodLocales.errors.positive),
});

export type MarkAsPaidModalSchema = z.infer<typeof markAsPaidModalSchema>;
